import axios from "axios";

// Create the Axios instance
const api = axios.create({
  baseURL: process.env.REACT_APP_SERVER_ADDRESS + "/api",
  headers: {
    "Content-Type": "application/json; charset=utf-8",
  },
});

// Add request interceptor to include token in headers
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Token = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;
